import React from 'react'
import numeral from 'numeral'
import { isEmpty } from 'lodash'
import petrovich from 'petrovich'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import { Helmet } from 'react-helmet'
import { get, getLots, getActiveLot, subsribe } from '../store/reducers/persons/info.js'
import { fetchingState } from '../helpers/hocs.js'

import { getTotalLotsSum } from '../selectors/person.js'

import MainContainer from './Main'
import Sidebar from './../components/Lot/Sidebar'
import Checkbox from '../components/Checkbox'
import SingleList from './LotList/singleList'

import BidHistory from './../components/Lot/BidHistory'
import PhoneConfirm from '../components/PhoneConfirm'
import { get as getFeedback, send as sendFeedback } from '../store/reducers/feedback'
import { getLoggedUser } from '../selectors/user.js'
import Overlay from '../components/Overlay'
import CloseButton from './../components/CloseButton'
import { sendMindbox } from '../helpers/hocs.js'

const getTitle = (name, gender, total = {}, intl) => {
  if (!name) return ''
  //name = petrovich({ gender, first: name.split(' ')[0] }, 'genitive').first
  return total.sum ? `${intl.formatMessage({id: 'member.with_participation_of_lot'})} ${name} ${intl.formatMessage({id: 'member.were_collected'})} ${numeral(total.sum).format('0,0')} ${(total.currency || '₽')}` : `${intl.formatMessage({id: 'member.with_participation_of_lot'})} ${name} ${intl.formatMessage({id: 'member.nothing_collected_2'})}`
}

const MembersPage = ({ lots = [], total, get, info = {}, active = null, isExists, subsribe, intl, submitApplication, success = null, showPhonePopup = false, setShowPhonePopup, setSuccess, sendApplication }) => (!isExists || isEmpty(info)) ? null : (

  success ? <div className='Contacts-form__title Head Message-body'>
      <CloseButton className='modal__close-button Message-close' onClick={()=>setSuccess(null)}/>
        <FormattedMessage id='fixedlot.request_sent' />
      </div>
        : (
    <MainContainer
      sidebarClass='Sidebar_person'
      Sidebar={<Sidebar data={info} image={info.photos && info.photos[0]} />}
    >
      <BidHistory items={lots} title={getTitle(`${info.firstname} ${info.lastname}`, info.gender, total, intl)} urlPrefix='funds' />
      <Helmet>
        <title>{info.name}</title>
        <meta name='description' content={info.description} />
        <meta property='og:title' content={info.name} />
        <meta property='og:image' content={info.photos} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={info.description} />
      </Helmet>
      {!active ?  <div className='completed-lot Text'>
                    <FormattedMessage id='lot.complete' />
                  </div> : null
      }
      <button className='Button Button_black' onClick={submitApplication}>
          {intl.formatMessage({id: 'members.wantToMeet'})}
        </button>
      <div className='Main__founds-control Text'>
        <div className='Main__control'><Checkbox checked={info.isSubscribed} onChange={subsribe} /></div>
        <span className='Main__control-label'>
          <FormattedMessage id='member.inform_me' />
        </span>
      </div>

      { info.description && <div className='Main__description Text' dangerouslySetInnerHTML={{ __html: info.description }} />}

    {active
      ? <SingleList items={[ active ]} title={intl.formatMessage({id: 'member.active_auction'})} />
      : //если нет активных аукционов
      <h1 className='SubHead'>
        <FormattedMessage id='member.no_active_auctions' />
      </h1>
      }
      <BidHistory show={true} items={ lots.filter(el => (el.status !== "active" && el.status !== "inactive" && el.status !== "declined")) } urlPrefix="funds" title={intl.formatMessage({id: 'member.previous_auctions'})} />
      <Overlay isActive={showPhonePopup} onClose={()=> setShowPhonePopup(false)} klassModifier='is--blured'>
          <PhoneConfirm onClose={()=> setShowPhonePopup(false)} submit={sendApplication}/>
        </Overlay>
    </MainContainer>
  )
)

const mapStateToProps = state => ({
  ...state.persons.info,
  total: getTotalLotsSum(state),
  user: getLoggedUser(state),
  person: state.feedback.info
})

const mapDispatchToProps = dispatch => bindActionCreators({ get, getLots, getActiveLot, subsribe, getFeedback, sendFeedback }, dispatch)

const mergeProps = (state, { get, getLots, getActiveLot, subsribe, ...dispatch }, props) => ({
  ...props,
  ...state,
  get: async (id) => {
    let memberId = id || props.id;
    let result = await props.fetchingWrap(get.bind(this, memberId), 'info')
    if (result === 200) {
      props.fetchingWrap(getLots.bind(this, memberId), 'lots')
      props.fetchingWrap(getActiveLot.bind(this, memberId), 'active')
    } else props.on404()
  },
  subsribe: async flag => {
    if (!props.id || !state.info) return
    await subsribe(props.id, !state.info.isSubscribed)
  },
  getFeedback: async () => {
    let result = await dispatch.getFeedback()
  },
  sendFeedback: (data) => {
    return(props.fetchingWrap(dispatch.sendFeedback.bind(this, data), 'send'))
  },
})

export default injectIntl(compose(
  withState('success', 'setSuccess', null),
  withState('showPhonePopup', 'setShowPhonePopup', false),
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
  withHandlers({
    sendApplication: ({info, sendFeedback, data, setSuccess, setShowPhonePopup, person, user}) => async (phone, e) => {
      e && e.preventDefault()
      //if (person.name && phone) {
        if(phone){
        setSuccess(null)
        data = {
          contact: phone,
          message: "Заявка на участника "+ info.name + " ("+info._id + ") от "+ (person.name? person.name: phone),
          name: person.name? person.name : phone,
          topic: "memberRequest",
          extra: {
            type: "memberId",
            value: info._id
          }
        }
        const result = await sendFeedback(data)
        if ((user && Object.keys(user).length > 0) && info) {
          const mindboxData = {
            "customer": {
              "mobilePhone": phone,
              "subscriptions": [
                {
                  "brand": "Meetforcharity",
                  "pointOfContact": "SMS",
                  "isSubscribed": info.isSubscribed
                }
              ]
            },
            "addProductToList": {
              "product": {
                "ids": {
                  "website": info._id
                }
              },
            },
            "executionDateTimeUtc": new Date()
          }

          sendMindbox(mindboxData, 'repeatVisit')
        }
        setShowPhonePopup(false)
        setSuccess(result === 200);
      }
    },
    //после нажатия на кнопку Оставить заявку, нужно открыть окно с подтверждением номера телефона
    submitApplication: ({person, setShowPhonePopup}) => async e => {
      e && e.preventDefault()
      //if (person.name && person.contact) {
        setShowPhonePopup(true)
      //}
    }
  }),
  
  withProps(({ init, fetching, info }) => ({
    isExists: !init || (!fetching.info && init)
  })),
  lifecycle({
    componentWillMount () {
      this.props.get()
      this.props.getFeedback()
    },
    componentWillReceiveProps (np) {
      if (np.id && (np.id !== this.props.id)) {
        this.props.get(np.id)
        this.props.getFeedback()
      }
      console.log('пропсы на повторную встречу************', np)
    }
  })
)(MembersPage))



// WEBPACK FOOTER //
// ./src/containers/Member.jsx